module.exports = __webpack_public_path__ + "catalog/items/bathroom/Shower-with-corner-drain/Shower-with-corner-drain.svg";